module.exports = __webpack_public_path__ + "static/media/Devpost.42a7d919.svg";